var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHotelOr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 21,
    viewBox: "0 0 30 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hotel",
    transform: "translate(-0.5 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10273",
    "data-name": "Path 10273",
    d: "M8.909,17a4,4,0,1,0-3.955-4A3.972,3.972,0,0,0,8.909,17Zm0-5.333A1.333,1.333,0,1,1,7.591,13,1.33,1.33,0,0,1,8.909,11.667Zm15.818-4H14.182V18.333H3.636V5H1V25H3.636V21H27.364v4H30V13A5.3,5.3,0,0,0,24.727,7.667Zm2.636,10.667H16.818v-8h7.909A2.659,2.659,0,0,1,27.364,13Z",
    fill: "#444",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelOr);
export default __webpack_public_path__ + "static/media/hotelOr.6d4bd8159b0665a8caf1d4d67e5a35f0.svg";
export { ForwardRef as ReactComponent };